import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import SideBarLink from '@/layout/components/sidebar/SideBarLink.vue';

import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
    sidebarLinks: {},
    lowerSidebarLinks: {}
  },
  setup(__props: any) {

const props = __props;

const { mdAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_navigation_drawer, {
      theme: "dark",
      rail: "",
      "expand-on-hover": "",
      "model-value": _unref(mdAndUp)
    }, {
      append: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.lowerSidebarLinks, (lowerSidebarLink) => {
              return (_openBlock(), _createBlock(SideBarLink, {
                key: lowerSidebarLink.name,
                "sidebar-link": lowerSidebarLink
              }, null, 8, ["sidebar-link"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.sidebarLinks, (sidebarLink) => {
              return (_openBlock(), _createBlock(SideBarLink, {
                key: sidebarLink.name,
                "sidebar-link": sidebarLink
              }, null, 8, ["sidebar-link"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})